<template>
  <div class="single-comment d-flex flex-column justify-space-between ga-3">
    <div class="header w-100 d-flex align-center justify-space-between">
      <div class="user-data d-flex align-center ga-2">
        <img
          class="circle-img"
          :src="comment.user.avatar"
          :alt="comment.user.name"
        />

        <span class="name">{{ comment.user.name }}</span>
      </div>
      <div class="time">{{ comment.time }}</div>
    </div>
    <div class="body" v-html="comment.content"></div>
    <div class="body">
      <v-row>
        <v-col
          v-for="img in comment.attachments"
          :key="img"
          class="d-flex child-flex"
          cols="4"
        >
          <v-img
            @click="showImage(img.preview)"
            :lazy-src="img.preview"
            :src="img.preview"
            aspect-ratio="1"
            class="bg-grey-lighten-2 rounded cursor-pointer"
            cover
          >
            <template v-slot:placeholder>
              <v-row align="center" class="fill-height ma-0" justify="center">
                <v-progress-circular
                  color="grey-lighten-5"
                  indeterminate
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
      <div class="mt-3" v-for="link in comment.links" :key="link">
        <a :href="link.href"> {{ link.name }}</a>
      </div>
    </div>

  </div>
  <v-overlay v-model="dialog" location="center" />
  <v-dialog v-model="dialog" width="auto">
    <v-card max-width="auto">
      <template v-slot:text>
        <img width="100%" :src="image_preview" alt="" />
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TaskComment",
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      image_preview: "",
      dialog: false,
    };
  },
  methods: {
    showImage(url) {
      this.image_preview = url;
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.single-comment {
  padding: 1rem;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.name {
  font-weight: 500;
}

.time {
  color: #666;
  font-size: 0.9rem;
}

.body {
  color: #333;
  line-height: 1.5;
}

.reply {
  color: #237276;
  cursor: pointer;
  font-weight: 500;
}

.circle-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
</style>
